(function () {
  'use strict';

  const BRAND = Object.freeze({
    fontBody: '"Nunito Sans", sans-serif',
    fontHeading: '"Montserrat", sans-serif',
    fontWeightHeading: '400',
    colorText: '#001135',
    colorBorder: '#e2e4e8',
    colorBg: '#f5f5f5',
    accent: '#001135',
    radius: '0px',
    textTextTransform: 'none',
    textLetterSpacing: '0',
    thresholdCents: 9000,
  });

  const IDS = Object.freeze({
    anchor: 'poc-cart-trust-box',
    bar: 'poc-free-shipping-bar',
    style: 'poc-free-shipping-bar-style',
  });

  const CART_MUTATION_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  const BAR_CSS = `
    #${IDS.bar}{
      max-height:0;
      overflow:hidden;
      padding:0 16px;
      border:1px solid ${BRAND.colorBorder};
      border-top:0;
      background:${BRAND.colorBg};
      opacity:0;
      text-align:center;
      font-family:${BRAND.fontBody};
      transition:max-height .3s ease,opacity .25s ease,padding .3s ease;
    }
    #${IDS.bar}.poc-fsb-visible{
      max-height:60px;
      padding:8px 16px;
      opacity:1;
    }
    #${IDS.bar} .poc-fsb-text{
      margin:0 0 5px;
      color:${BRAND.colorText};
      font-family:${BRAND.fontHeading};
      font-size:12px;
      font-weight:${BRAND.fontWeightHeading};
      letter-spacing:${BRAND.textLetterSpacing};
      text-transform:${BRAND.textTextTransform};
    }
    #${IDS.bar} .poc-fsb-amount{color:${BRAND.accent};}
    #${IDS.bar} .poc-fsb-track{
      max-width:420px;
      height:6px;
      margin:0 auto;
      overflow:hidden;
      border-radius:${BRAND.radius};
      background:${BRAND.colorBorder};
    }
    #${IDS.bar} .poc-fsb-fill{
      width:0;
      height:100%;
      border-radius:${BRAND.radius};
      background:${BRAND.accent};
      transition:width .35s ease;
    }
  `;

  let refreshTimer = null;

  function formatMoney(cents) {
    return `$${(cents / 100).toFixed(2)}`;
  }

  function injectStyle() {
    if (document.getElementById(IDS.style)) return;
    const style = document.createElement('style');
    style.id = IDS.style;
    style.textContent = BAR_CSS;
    document.head.appendChild(style);
  }

  function createBar(anchor) {
    const bar = document.createElement('div');
    bar.id = IDS.bar;
    bar.setAttribute('role', 'status');
    bar.setAttribute('aria-live', 'polite');

    const text = document.createElement('p');
    text.className = 'poc-fsb-text';

    const track = document.createElement('div');
    track.className = 'poc-fsb-track';
    track.setAttribute('aria-hidden', 'true');

    const fill = document.createElement('div');
    fill.className = 'poc-fsb-fill';
    track.appendChild(fill);
    bar.append(text, track);
    anchor.insertAdjacentElement('afterend', bar);
    return bar;
  }

  function ensureBar() {
    const existing = document.getElementById(IDS.bar);
    if (existing) return existing;

    // Deliberately cart-only. The threshold remains visible at the point where
    // basket-building is relevant, without turning it into a PDP objection.
    const cartAnchor = document.getElementById(IDS.anchor);
    return cartAnchor ? createBar(cartAnchor) : null;
  }

  function render(cart) {
    const bar = ensureBar();
    if (!bar) return;

    if (!cart || cart.item_count < 1) {
      bar.classList.remove('poc-fsb-visible');
      return;
    }

    const text = bar.querySelector('.poc-fsb-text');
    const fill = bar.querySelector('.poc-fsb-fill');
    const remaining = BRAND.thresholdCents - cart.total_price;
    const progress = Math.min(100, Math.max(0, (cart.total_price / BRAND.thresholdCents) * 100));

    text.replaceChildren();
    if (remaining <= 0) {
      text.textContent = "You've unlocked free shipping!";
    } else {
      const amount = document.createElement('span');
      amount.className = 'poc-fsb-amount';
      amount.textContent = formatMoney(remaining);
      text.append('Add ', amount, ' more for free shipping');
    }

    fill.style.width = `${progress}%`;
    bar.classList.add('poc-fsb-visible');
  }

  function refresh() {
    if (!document.getElementById(IDS.anchor)) return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then((response) => {
        if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
        return response.json();
      })
      .then(render)
      .catch(() => {});
  }

  function scheduleRefresh() {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refresh, 150);
  }

  function observeCartAnchor() {
    if (document.getElementById(IDS.anchor)) {
      refresh();
      return;
    }

    const observer = new MutationObserver(() => {
      if (!document.getElementById(IDS.anchor)) return;
      observer.disconnect();
      refresh();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function watchCartRequests() {
    const originalFetch = window.fetch;
    if (typeof originalFetch === 'function') {
      window.fetch = function (input) {
        const url = typeof input === 'string' ? input : (input && input.url) || '';
        const request = originalFetch.apply(this, arguments);
        if (CART_MUTATION_RE.test(url)) request.then(scheduleRefresh).catch(() => {});
        return request;
      };
    }

    const originalOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (CART_MUTATION_RE.test(String(url))) {
        this.addEventListener('loadend', scheduleRefresh, { once: true });
      }
      return originalOpen.apply(this, arguments);
    };
  }

  function init() {
    injectStyle();
    observeCartAnchor();
    watchCartRequests();
    document.addEventListener('cart:updated', scheduleRefresh);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
